import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.get(root + '/order/salecontract/list', {params: params})
}


//删除行
export const deleteData = (params) => {
  return axios.post(root + '/order/salecontract/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root + '/order/salecontract/detail', {params: params})
}

//保存某一行的数据
export const saveData = (params) => {
  if (JSON.parse(params.form).unitguid) {//修改
    return axios.post(root + '/order/salecontract/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/order/salecontract/save', qs.stringify(params))
  }
}

//获取某条合同的统计数据
export const getTJByUnitGuid = (params) => {
  return axios.get(root + '/order/salecontract/getTJByUnitGuid', {params: params})
}

//根据最新的商品价格计算已完成额
export const calculateNewMoney = (params) => {
  return axios.get(root + '/order/salecontract/calculateNewMoney', {params: params})
}




// WEBPACK FOOTER //
// ./src/api/order/salecontract.js